<template>
	<div
		data-aos="fade-up"
		class="min-h-80 flex flex-col border-2 border-foreground rounded-3xl p-5 backdrop-blur-8 md:min-h-120">
		<div class="flex flex-col gap-2">
			<h3 class="text-xl">
				جستجو در اینترنت
			</h3>

			<p class="text-foreground/60">
				از مدل های مختلف و به روز با یک پلن استفاده کنید.
			</p>
		</div>

		<NuxtImg
			loading="lazy"
			src="/website/feature-search.svg"
			width="340"
			height="270"
			class="m-auto" />
	</div>
</template>
